import Axios from "../../Config/API";
import Service from "../../Service";

export async function PropostasCasoVendasService(idCaso: number) {
    return Service(
        Axios.get(`/home/propostas/listarpropostaporcaso?idCaso=${idCaso}`)
    );
}
